import {createSelector} from 'reselect';

const getNodeComponents = (ownProps) => ownProps.nodeComponents;
const getNodeOptions = (ownProps) => ownProps.nodeOptions;

const updateNodeComponents = createSelector(
  [getNodeComponents, getNodeOptions],
  (componentsList, optionsList) => {
    return componentsList.map((component) => {
      let componentFromOptions = {};
      if (component.droppedId !== null) {
        componentFromOptions = optionsList.find(
          (option) => option.id === component.droppedId
        );
      }
      return {...component, ...componentFromOptions, id: component.id};
    });
  }
);

/**
 * Reselect Method used By Protocoal Component to
 * fetch their corrosponding redux props.
 */
const getApparatusByIndex = ({reducer: {allApparatus}}, {id}) =>
  allApparatus[id];

const getApparatusProps = createSelector(
  [getApparatusByIndex],
  (centrifuge) => centrifuge
);

export const Reselect = {
  updateNodeComponents,
  getApparatusProps,
};
